import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RoadmapStrategyRoadmapRoute extends Route {
  @service store;
  @service router;

  beforeModel() {
    this.router.on('routeDidChange', this.redirectToInnerPage);
    this.router.on('routeWillChange', this.blockInnerToParentPage);
  }

  redirectToInnerPage = (transition) => {
    if (transition?.to?.name === 'roadmap.strategy.roadmap.index')
      this.router.transitionTo('roadmap.strategy.roadmap.grid');
  };

  blockInnerToParentPage = (transition) => {
    if (
      transition?.to?.name === 'roadmap.strategy.roadmap.index' &&
      [
        'roadmap.strategy.roadmap.grid',
        'roadmap.strategy.roadmap.lanes',
      ].includes(transition?.from?.name)
    )
      transition.abort();
  };

  model(params) {
    return this.store.findRecord('roadmap', params.roadmap_id);
  }

  @action
  error(error) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('planning.dashboard');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.router.off('routeDidChange', this.redirectToInnerPage);
      this.router.off('routeWillChange', this.blockInnerToParentPage);
    }
  }
}
